import React, { Component } from 'react';
import _ from 'lodash';
import FontAwesome from 'react-fontawesome';
import DonorCategoriesSide from './DonorCategoriesSide';
import ReactIScroll from 'react-iscroll';
var iScroll = require('iscroll/build/iscroll-probe')
import shared from '../../utils/shared.js'
import { connect } from 'react-redux';

const scrollMultiplier = 10
const scrollDelay = 3000

//var requestId;

class DonorList extends Component {

  constructor(props) {
    console.log("donor-list");
    super(props);
    this.refDict = {};
    this.scrollRef = {};
    this.prepareDonors = this.prepareDonors.bind(this);
    this.outputDonors = this.outputDonors.bind(this);
    this.scrollToBottom = this.scrollToBottom.bind(this);
    this.resetTimer = this.resetTimer.bind(this);
    this.handleCategoriesSlide = this.handleCategoriesSlide.bind(this);
    this.toggleSlideOn = this.toggleSlideOn.bind(this);
    this.toggleSlideOff = this.toggleSlideOff.bind(this);
    this.setInitialLocation = this.setInitialLocation.bind(this);
    this.handleSlideCategoryChange = this.handleSlideCategoryChange.bind(this);
    this.donorlines = [];
    this.handleCategoryChange = this.handleCategoryChange.bind(this);
    this.state = {
      selectedCategory: null,
      donorsGrouped: null,
      displayCategories: false,
      userScrolling: true,
      initialLocationSet: false,

    }
    this.scrollTimeout = null; //for auto scrolling

    //this.newScroll = Scroll.animateScroll
  }

  componentWillMount() {
    shared.checkData(this.props.module);
  }

  componentDidMount() {
    this.prepareDonors();
    // this.resetTimer(1000);
  }

  componentDidUpdate() {
    // if (this.state.userScrolling===true){
    // this.resetTimer(scrollDelay);
    // }
    //  if (this.state.donorsGrouped!==null){

    //   }
  }

  componentWillUnmount() {
    //window.cancelAnimationFrame(requestId);
    //requestId = undefined;
    clearTimeout(this.scrollTimeout);
    this.scrollTimeout = null
    //     Events.scrollEvent.remove('begin');
    //     Events.scrollEvent.remove('end');

  }

  shouldComponentUpdate(prevProps, prevState) {
    if (shared.shallowEqual(this.state, prevState)) {
      return false;
    }
    return true;
  }

  setInitialLocation() {
    if (this.state.initialLocationSet === false) {
      if (this.scrollRef[0]) {
        let jumptodonor = shared.parseStringParam(this.props.history.location.search, "donor");
        if (jumptodonor) {
          _.forEach(this.donorlines, (donor) => {
            if (donor.id === jumptodonor) {
              this.scrollRef[0].withIScroll((iScroll) => {
                iScroll.scrollToElement(donor, null, 0, -this.props.screen.r16_9.p10, false);
                return true;
              })
            }
          })
          this.setState({
            initialLocationSet: true
          })
        }
        else {
          this.scrollRef[0].withIScroll((iScroll) => {
            iScroll.scrollTo(0, -this.props.screen.r16_9.p10 * 6);
          })
          this.setState({
            initialLocationSet: true
          })
        }
      }
    }
  }

  scrollToBottom() {
    let max = Math.abs(this.scrollRef[0]._iScrollInstance.maxScrollY);
    let current = Math.abs(this.scrollRef[0]._iScrollInstance.y);
    let remaining = max - current;
    let seconds = (remaining / 1000) * 5000 * scrollMultiplier //5 seconds per 1000 pixels
    let customEase = iScroll.utils.ease.quadratic
    customEase.style = "cubic-bezier(0, 0, 1, 1)"
    //0.250, 0.250, 0.750, 0.750
    this.scrollRef[0].withIScroll((iScroll) => {
      //iScroll.scrollTo(0, -max, seconds, customEase);
      iScroll.scrollTo(0, -max, seconds, customEase);
    })

    this.setState({
      userScrolling: false
    })
  }

  onScrollStart = () => {
    this.setState({
      userScrolling: true
    })
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout)
      this.scrollTimeout = null
    }
    this.resetTimer(scrollDelay);

  }

  onScrollEnd = (e) => {
    this.props.resume();
    if (e.y === e.maxScrollY && this.state.userScrolling === false) {
      this.scrollRef[0].withIScroll((iScroll) => {
        iScroll.scrollTo(0, 0);
        this.resetTimer(500);
      })
    }
    this.setState({
      userScrolling: false
    })
  }

  resetTimer(time) {
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout)
      this.scrollTimeout = null
    }

    this.scrollTimeout = setTimeout(() => {
      this.scrollToBottom();
      this.scrollTimeout = null
    }, time)
  }


  handleCategoriesSlide() {
    if (this.state.displayCategories === false) {
      this.toggleSlideOn();
    }
    else {
      this.toggleSlideOff();
    }
  }

  toggleSlideOff() {
    this.setState({
      displayCategories: false
    })
  }

  toggleSlideOn() {
    this.setState({
      displayCategories: true
    })
  }

  handleDonorClick(e, row) {
    //e.target.scrollTop = 0;
    //console.log(e.target.top);
    //var elemRect = e.target.getBoundingClientRect();
    //var elemViewportOffset = elemRect.top;
    //console.log(elemViewportOffset);
    //e.target.scrollIntoView({ block: 'end', behavior: 'smooth' });
    //  this.refs.test.scrollTop = elemViewportOffset;
  }

  jumpToCategory(e) {
    // e.target.scrollIntoView({ block: 'end', behavior: 'smooth' });

  }

  handleSlideCategoryChange(categoryId) {
    this.toggleSlideOff();
    this.handleCategoryChange({ value: categoryId })
  }

  handleCategoryChange(val) {
    this.setState({
      selectedCategory: val.value
    })
    let jumpTo = null;
    for (var i = 0; i < this.state.donorsGrouped.length; i++) {
      if (val.value === this.state.donorsGrouped[i].id) {
        jumpTo = i;
      }
    }
    if (jumpTo !== null) {
      this.scrollRef[0].withIScroll((iScroll) => {
        iScroll.disable();
        iScroll.enable();
        iScroll.scrollToElement(this.refDict[jumpTo], null, 0, -this.props.screen.r16_9.p10, false)
      })
    }
  }

  prepareDonors() {
    if (this.props.donors.donorCategories.length === 0) {
      this.setState({
        donorsGrouped: []
      })
      return;
    }
    let donorsGrouped = [];

    // if (!this.props.module.contents.donor_view_category){

    // } 

    //console.log("include categories", this.props.module.contents.include_categories);

    _.forEach(this.props.donors.donorCategories, (category) => {
      if (category.donors.length > 0) {
        _.forEach(this.props.module.contents.include_categories, (icat) => {
          if (icat === category.id) {
            let pushGroup = { id: category.id, name: category.name, subheader: category.subheader, donors: [] };
            _.forEach(category.donors, (dnr) => {
              pushGroup.donors.push(dnr);
            });
            donorsGrouped.push(pushGroup);
          }
        });
      }
    });
    this.setState({
      donorsGrouped: donorsGrouped
    })
  }

  outputName(donorCat, i) {
    let style = {
      fontSize: this.props.screen.r16_9.p10 * .6,
      lineHeight: String(this.props.screen.r16_9.p10 * .6 * .78) + "px",
    }
    return (
      <div ref={el => this.refDict[i] = el} onMouseDown={(e) => this.jumpToCategory(e)} style={style}>
        <b>{donorCat.name}</b>
      </div>
    )
  }

  outputSubheader(donorCat, i) {
    let style = {
      fontSize: this.props.screen.r16_9.p10 * .4,
      lineHeight: String(this.props.screen.r16_9.p10 * .4 * .78) + "px",
      pointerEvents: 'auto',
      zIndex: 100
    }
    if (donorCat.subheader) {
      return (
        <div style={style}>
          <b>{donorCat.subheader}</b>
        </div>
      )
    }
    return (
      <div />
    )
  }

  outputDonorInfo(donorCat) {
    return (
      donorCat.donors.map(function (row, i) {
        //if row.id===param scroll
        //check if SET ABOVE specific donor id param, if so if its a match render the ref to a different ref??
        return (
          <span id={row.id} ref={(el) => { this.donorlines.push(el) }} onMouseDown={(e) => this.handleDonorClick(e)} style={{ width: '100%', marginBottom: this.props.screen.r16_9.p10 * .125, marginTop: this.props.screen.r16_9.p10 * .125, fontSize: this.props.screen.r16_9.p10 * .3, display: "inline-block" }} key={i}>
            {row.name}
          </span>
        )
      }, this)
    )
  }

  outputDonors(donorCat) {
    return (
      donorCat.map(function (row, i) {
        let title = this.outputName(row, i);
        let subheader = this.outputSubheader(row, i);
        let donors = this.outputDonorInfo(row);
        return (
          <div key={i} style={{ width: '100%' }}>
            <div style={{ height: this.props.screen.r16_9.p10 * .35 }} />
            {title}
            <div style={{ height: this.props.screen.r16_9.p10 * .175 }} />
            {subheader}
            <div style={{ height: this.props.screen.r16_9.p10 * .35 }} />
            <div className="threecolumn">
              {donors}
            </div>
          </div>
        )
      }, this)
    )
  }

  render() {


    let navClass = "";
    let backDropClass = "backdropOff";
    if (this.state.displayCategories === true) {
      navClass += " on";
      backDropClass = "backdropOn";
    }

    let navButtonStyle = {
      color: 'white',
      position: 'fixed',
      height: this.props.screen.screenHeight * .065,
      width: this.props.screen.screenHeight * .065,
      fontSize: this.props.screen.screenHeight * .025,
      left: this.props.screen.r16_9.left + this.props.screen.r16_9.p10,
      bottom: this.props.screen.r16_9.p10 * 2,
      zIndex: 99,
      textAlign: 'left'
    }

    let headlineText = {
      textAlign: 'vertical',
      display: 'inline-block',
      color: 'black',
      fontSize: this.props.screen.r16_9.p10 * .6,
      lineHeight: String(this.props.screen.r16_9.p10 * .6 * .78) + "px",
      position: 'absolute',
      width: this.props.screen.r16_9.screenWidth
    }

    if (this.state.donorsGrouped === null) {
      return (
        <div />
      );
    }
    let donorCats = this.state.donorsGrouped;
    let donorsOutput = this.outputDonors(donorCats);

    let options = []

    _.forEach(donorCats, (dc) => {
      options.push({ value: dc.id, label: dc.name })
    })

    let u10 = this.props.screen.r16_9.p10;
    let leftWidth = this.props.screen.r16_9.left + this.props.screen.r16_9.width / 6;
    let innerRightWidth = this.props.screen.r16_9.width - this.props.screen.r16_9.width / 6
    let rightWidth = this.props.screen.screenWidth - leftWidth;

    return (

      <div style={{ width: '100vw', height: '100vh', position: 'absolute' }}>
        <div onMouseDown={this.toggleSlideOff} className={backDropClass} />

        <div style={{ position: 'fixed', top: 0, left: leftWidth, width: rightWidth, height: this.props.screen.screenHeight, backgroundColor: 'white', color: 'black', pointerEvents: 'none' }} />

        <div className="phand" style={{ color: 'black', position: 'fixed', left: leftWidth + u10, top: 0, height: u10 * 2, width: rightWidth, backgroundColor: 'white' }} >
          <div style={{ backgroundColor: 'white', position: 'absolute', top: u10, fontSize: u10 * 2, width: '100%' }}>
            <span style={headlineText}><b>{this.props.module.contents.headline ? this.props.module.contents.headline : "Donor Headline"}</b></span>
          </div>
        </div>

        <div style={{ position: 'fixed', top: u10 * 2, left: leftWidth + u10, width: innerRightWidth - u10, height: u10 * 7, backgroundColor: 'white', color: 'black', pointerEvents: 'auto' }}>
          <div className="phand" style={{ lineHeight: '1.25', height: u10 * 7, width: innerRightWidth - (u10 * 2), touchAction: "none" }} >
            <ReactIScroll ref={el => this.scrollRef[0] = el} iScroll={iScroll}
              options={{
                mouseWheel: true,
                scrollbars: false,
                scrollX: false,
                scrollY: true,
                probeType: 2,
                bounce: false,
                momentum: true,
                deceleration: 0.015,
                useTransition: true,
                disableTouch: false,
                disablePointer: false,
                disableMouse: false
              }} onScrollStart={this.onScrollStart}
              onScrollEnd={this.onScrollEnd}
              onRefresh={this.setInitialLocation}
            >
              <div>
                <div style={{ height: u10 * 7 }} />
                {donorsOutput}
                <div style={{ height: u10 * 7 }} />
              </div>
            </ReactIScroll>
          </div>


        </div>

        <div className="topgrad" style={{ pointerEvents: 'none', position: 'fixed', top: u10 * 2, left: leftWidth + u10, width: innerRightWidth - u10, height: u10 * 1 }} />
        <div className="bottomgrad" style={{ pointerEvents: 'none', position: 'fixed', top: u10 * 8, left: leftWidth + u10, width: innerRightWidth - u10, height: u10 * 1.1 }} />

        <br style={{ clear: 'both' }} />
        {/*<div className="searchButton" style={searchButtonStyle}>
                    <span style={{ position: 'absolute', bottom: 0 }}>
                        <FontAwesome name='search' size='2x' />
                    </span>
                </div>*/}

        <div id="slideout" className={navClass}>
          <DonorCategoriesSide handleSlideCategoryChange={this.handleSlideCategoryChange} donorCats={donorCats} screen={this.props.screen} />
        </div>

        <span className="phand" onMouseDown={this.handleCategoriesSlide} style={navButtonStyle}>
          <span style={{ position: 'absolute', bottom: 0 }}>
            <FontAwesome name='sitemap' size='2x' />
          </span>
        </span>


      </div>
    );
  }
}

const mapStateToProps = (state) => {

  let mod = state.content.dm_active[state.active_module];
  let isIdle = shared.parseStringParam(window.location.href, "idle");
  //console.log("is idle is this", isIdle)
  if (isIdle === 'true') {
    mod = state.content.display_module_loops[0].display_module_loop_units[state.active_module].data; //.display_module.data    
  }
  //console.log("found this mod: ", mod)
  return {
    screen: state.screen,
    module: mod,
    donors: state.donors
  };
};

export default connect(mapStateToProps, null)(DonorList);



// WEBPACK FOOTER //
// ./src/Components/Donor/DonorList.js